// extracted by mini-css-extract-plugin
export var container = "_dv-0";
export var containerTopRight = "_dv-1";